<form [formGroup]="loginPinForm" (submit)="login()">
    <div *ngIf="loginError" class="form-row mb-2">
        <div class="col-12">
            <alert type="danger" [dismissible]="dismissible" (onClosed)="onClosed(alert)">{{ alert
                }}</alert>
        </div>
    </div>
    <div class="form-row mb-2">
        <div class="col-12">
            <select [compareWith]="compareFn" class="form-control" formControlName="username" [ngClass]="{ 'is-invalid': controls.username.errors && controls.username.touched }">
                <option class="lg-opt" *ngFor="let user of users" [value]="user.Username">{{user.Username}}</option>
            </select>
            <div *ngIf="loginPinForm.invalid" class="invalid-feedback">
                <div *ngIf="controls.username.hasError('required') && controls.username.touched">Username is
                    required</div>
            </div>
        </div>
    </div>
    <div class="form-row mb-4">
        <div class="col-12">
            <input type="password" class="form-control" formControlName="pin" placeholder="Pin" [ngClass]="{ 'is-invalid': controls.pin.errors && controls.pin.touched }">
            <div *ngIf="loginPinForm.invalid" class="invalid-feedback">
                <div *ngIf="controls.pin.hasError('required') && controls.pin.touched">Pin
                    is required</div>
            </div>
        </div>
    </div>
    
    <div class="form-row mb-4">
        <div class="form-group col-12 sign-in-button">
            <button class="btn btn-primary btn-block" [disabled]="!loginPinForm.valid">SIGN IN</button>
            <button *ngIf="isTrainingRequestsEnabled" type="button" class="btn btn-link-outline btn-block" (click)="loginAndNavigateToRequestTraining()">
				REQUEST TRAINING
			</button>
        </div>
    </div>
</form>
